import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { catchError, finalize, of, pipe, switchMap, tap } from 'rxjs';
import { initialPartnerDashboardState, PartnerDashboardState } from '../models/state/partner-dashboard.state';
import { CustomerService, PentestService } from '../services';
import { SelectedPartnerStore } from './selected-partner.store';

export const PartnerDashboardStore = signalStore(
  withState<PartnerDashboardState>(initialPartnerDashboardState),
  withMethods(
    (
      store,
      pentestService = inject(PentestService),
      customerService = inject(CustomerService),
      partnerSignal = inject(SelectedPartnerStore)?.selectedPartner,
    ) => ({
      loadPartnerPentestScanStatistics: rxMethod<void>(
        pipe(
          tap(() => patchState(store, { partnerPentestScanStatisticsLoading: true })),
          switchMap(() =>
            pentestService.getPartnerPentestScanStatistics(partnerSignal()?.id).pipe(
              tap((partnerPentestScanStatistics) => patchState(store, { partnerPentestScanStatistics })),
              catchError(() => {
                patchState(store, { partnerPentestScanStatistics: [] });
                return of();
              }),
              finalize(() => patchState(store, { partnerPentestScanStatisticsLoading: false })),
            ),
          ),
        ),
      ),
      loadCustomers: rxMethod<void>(
        pipe(
          tap(() => patchState(store, { customersLightLoading: true })),
          switchMap(() =>
            customerService.getAllPartnerCustomersLight(partnerSignal()?.id).pipe(
              tap((customersLight) => patchState(store, { customersLight })),
              catchError(() => {
                patchState(store, { customersLight: [] });
                return of();
              }),
              finalize(() => patchState(store, { customersLightLoading: false })),
            ),
          ),
        ),
      ),
    }),
  ),
);
